import api from '@/services/api';

const state = {
  isAuthenticated: false,
  user: null,
};

const getters = {
  isAuthenticated: (s) => s.isAuthenticated,
  user: (s) => s.user,
};

const actions = {
  async login({ commit }, credentials) {
    const res = await api.post('/auth/login', credentials);
    commit('SET_AUTH', true);
    // ownerBusinessName/billingExpiryDate ride alongside `user` in the
    // login response — folded onto the user object here so the rest of
    // the app has one flat shape to read from, regardless of whether it
    // came from /login or /me.
    commit('SET_USER', {
      ...res.data.user,
      ownerBusinessName: res.data.ownerBusinessName,
      billingExpiryDate: res.data.billingExpiryDate,
    });
  },

  async register(_, payload) {
    const res = await api.post('/auth/register', payload);
    return res.data; // { message, userId } — no session yet
  },

  async verifyOtp({ commit }, payload) {
    const res = await api.post('/auth/register/verify-otp', payload);
    commit('SET_AUTH', true);
    commit('SET_USER', res.data.user);
    return res.data;
  },

  async resendOtp(_, payload) {
    const res = await api.post('/auth/register/resend-otp', payload);
    return res.data;
  },

  async restoreSession({ commit }) {
    try {
      const res = await api.get('/auth/me');
      commit('SET_AUTH', true);
      commit('SET_USER', res.data);
    } catch {
      commit('LOGOUT');
    }
  },

  async logout({ commit }) {
    await api.post('/auth/logout');
    commit('LOGOUT');
  },
};

const mutations = {
  SET_AUTH(state, value) {
    state.isAuthenticated = value;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  LOGOUT(state) {
    state.isAuthenticated = false;
    state.user = null;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
